module.exports = __webpack_public_path__ + "static/i-phone-vertical-a981be7e558c47d0f07812e85252b4d6.png";